/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/no-extraneous-dependencies */
import React, {
  useContext, useEffect, useState,
} from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { Modal, Box } from '@mui/material';
import { AlertTriangle, HelpCircle, X } from 'lucide-react';
import { Navbar, Sidebar } from '../../components';
import { sendRequest } from '../../api/shootAPI';
import { NotificationContext } from '../../contexts/Notification';
import { UserContext } from '../../contexts/User';
import API from '../../api/endpoints';
import DateRangePicker from '../../components/dateRangePicker';
import './analytics.css';
import { formatSeconds } from '../../utils/time';
import DataTable from '../../components/DataTable';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../utils/styledSelect';

const PAGE_SIZE_DEFAULT = 10;
const TIMEZONES = moment.tz.names();

const CONFIDENCE_TONE = {
  high: { bg: '#FCECE7', fg: '#CC4525' },
  medium: { bg: '#FDF1E3', fg: '#B3650F' },
  low: { bg: '#E7F6E6', fg: '#256D23' },
};

function StatCard({ title, value }) {
  return (
    <div className="flex-1 bg-white border border-rule rounded-[12px] px-4 py-3" style={{ borderStyle: 'solid', minWidth: 160 }}>
      <p className="text-xs font-medium text-ink-500 mb-1">{title}</p>
      <p className="text-2xl font-semibold text-ink-900 tabular-nums">{value}</p>
    </div>
  );
}

function ConfidenceBadge({ value }) {
  const tone = CONFIDENCE_TONE[String(value || '').toLowerCase()] || CONFIDENCE_TONE.low;
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold" style={{ background: tone.bg, color: tone.fg }}>
      {value}
    </span>
  );
}

function UnusualActivity() {
  const { activeWorkspace } = useContext(UserContext);
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState(0);
  const [members, setMembers] = useState([]);
  const [summary, setSummary] = useState({ totalMembers: 0, totalInstances: 0, totalTime: 0 });
  const [selectedTimezone, setSelectedTimezone] = useState(activeWorkspace.timezone);
  const [date, setDate] = useState(() => {
    const initialToday = moment.tz(selectedTimezone).toDate();
    return [moment.tz(selectedTimezone).subtract(6, 'days').toDate(), initialToday];
  });
  const [totalCounts, setTotalCounts] = useState(0);
  const { displayNotification } = useContext(NotificationContext);
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAbout, setShowAbout] = useState(false);

  const fetchTeams = async () => {
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getAllTeamInfo(activeWorkspace.id),
      timeout: 30000,
    });
    if (success) {
      setTeams(data.teams);
    } else {
      displayNotification({
        message: 'There was an issue fetching team data. Please try again',
        severity: 'error',
      });
    }
  };

  const fetchMembers = async () => {
    setIsLoading(true);

    const startOfDay = moment.tz(date[0], selectedTimezone)
      .startOf('day').clone().utc()
      .format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment.tz(date[1], selectedTimezone)
      .endOf('day').clone().utc()
      .format('YYYY-MM-DD HH:mm:ss');

    const { success, data: res } = await sendRequest({
      method: 'get',
      url: API.UNUSUAL_ACTIVITY.getWorkspaceSummary(activeWorkspace.id),
      params: {
        startDate: startOfDay,
        endDate: endOfDay,
        teamId: selectedTeamId,
        page: currentPage,
        pageSize,
        timezone: selectedTimezone,
      },
      timeout: 30000,
    });

    const { data } = res ?? { success: false, data: { members: [] } };
    if (success) {
      setMembers(data.members ?? []);
      setTotalCounts(data.pagination.totalCounts);
      setSummary(data.summary);
    } else {
      displayNotification({
        message: 'There was an issue fetching unusual activity. Please try again',
        severity: 'error',
      });
    }
    setIsLoading(false);
  };

  const handlePageChange = (next) => setCurrentPage(next);

  const handlePageSizeChange = (size) => {
    setCurrentPage(1);
    setPageSize(size);
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTeamId, date, currentPage, pageSize, selectedTimezone]);

  useEffect(() => {
    fetchTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      key: 'name',
      label: 'Member',
      width: 240,
      flex: true,
      render: (m) => <span className="font-medium text-ink-900">{m.member?.user?.fullName || '—'}</span>,
    },
    {
      key: 'totalTime',
      label: 'Total Time',
      width: 150,
      render: (m) => <span className="tabular-nums text-ink-700">{formatSeconds(m.totalTime ?? 0, { showSeconds: true, roundToNearestMinute: false })}</span>,
    },
    {
      key: 'previousDays',
      label: 'Previous 60 days',
      width: 160,
      render: (m) => <span className="tabular-nums text-ink-700">{formatSeconds(m.previousDays ?? 0, { showSeconds: true, roundToNearestMinute: false })}</span>,
    },
    {
      key: 'confidence',
      label: 'Confidence',
      width: 130,
      render: (m) => <ConfidenceBadge value={m.confidence} />,
    },
    {
      key: 'action',
      label: '',
      width: 110,
      align: 'right',
      render: (m) => (
        <Link to={`/analytics/unusual-activity/${m.memberId}`} onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="inline-flex items-center justify-center px-3 py-1.5 rounded-[8px] text-[11px] font-semibold uppercase tracking-wider text-ink-900 bg-white border border-rule hover:border-brand-500 hover:text-brand-700 transition"
            style={{ borderStyle: 'solid', letterSpacing: '0.05em' }}
          >
            View
          </button>
        </Link>
      ),
    },
  ];

  return (
    <>
      <Navbar />
      <Sidebar />

      {showAbout && (
        <Modal open onClose={() => setShowAbout(false)} className="flex-row align-c jstfy-c">
          <Box style={{ width: 520, maxWidth: 'calc(100% - 32px)', maxHeight: '90vh', overflowY: 'auto', background: '#fff', borderRadius: 12, fontFamily: 'Inter, sans-serif' }}>
            <div className="flex items-center justify-between px-6 pt-5 pb-3">
              <h5 className="inline-flex items-center gap-2 text-lg font-semibold leading-none text-ink-900">
                <AlertTriangle size={18} className="text-[#CC4525]" />
                About Unusual Activity
              </h5>
              <button type="button" aria-label="Close" onClick={() => setShowAbout(false)} className="text-ink-500 hover:text-ink-900 bg-transparent border-0 cursor-pointer p-0">
                <X size={20} />
              </button>
            </div>

            <div className="px-6 pt-2 pb-5 flex flex-col gap-4">
              <p className="text-sm text-ink-700 leading-relaxed">
                Unusual Activity flags members whose tracked time in the selected period differs noticeably
                from their normal pattern over the previous 60 days — helping you spot sudden spikes or drops
                that may be worth a closer look.
              </p>

              <div>
                <h6 className="text-sm font-semibold text-ink-900 mb-2">What the columns mean</h6>
                <ul className="flex flex-col gap-1.5 text-sm text-ink-700" style={{ paddingLeft: 18, listStyle: 'disc' }}>
                  <li><span className="font-medium text-ink-900">Total Time</span> — tracked time for the selected date range.</li>
                  <li><span className="font-medium text-ink-900">Previous 60 days</span> — the member&apos;s typical baseline over the prior 60 days.</li>
                  <li><span className="font-medium text-ink-900">Confidence</span> — how strongly the current activity deviates from that baseline.</li>
                </ul>
              </div>

              <div>
                <h6 className="text-sm font-semibold text-ink-900 mb-2">Confidence levels</h6>
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2"><ConfidenceBadge value="High" /><span className="text-sm text-ink-700">Strong deviation — worth reviewing.</span></div>
                  <div className="flex items-center gap-2"><ConfidenceBadge value="Medium" /><span className="text-sm text-ink-700">Moderate deviation from the baseline.</span></div>
                  <div className="flex items-center gap-2"><ConfidenceBadge value="Low" /><span className="text-sm text-ink-700">Minor deviation — usually expected variation.</span></div>
                </div>
              </div>

              <p className="text-sm text-ink-500">
                Use the date range, team, and timezone filters to scope the results, and select
                {' '}
                <span className="font-medium text-ink-700">View</span>
                {' '}
                on any member to see the detailed evidence.
              </p>
            </div>

            <div className="flex justify-end px-6 pb-5 pt-1">
              <button type="button" onClick={() => setShowAbout(false)} className="inline-flex items-center justify-center box-border h-10 px-5 rounded-[8px] text-sm font-semibold text-white bg-brand-700 hover:bg-[#1a3156] transition">
                Got it
              </button>
            </div>
          </Box>
        </Modal>
      )}

      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          {/* Header — title left, About + filters top-right */}
          <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between mb-5">
            <h1 className="font-bold text-ink-900 leading-tight text-2xl lg:text-[32px] lg:leading-10 flex-shrink-0" data-testid="title" data-tour="unusual-activity">
              Unusual Activity
            </h1>
            <div className="flex flex-wrap items-center gap-2 xl:justify-end">
              <button
                type="button"
                onClick={() => setShowAbout(true)}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-ink-500 hover:text-brand-700 bg-transparent border-0 cursor-pointer p-0 mr-1 transition"
              >
                <HelpCircle size={16} />
                About Unusual Activity
              </button>
              <select
                value={selectedTeamId}
                onChange={(e) => { setSelectedTeamId(Number(e.target.value)); setCurrentPage(1); }}
                className={STYLED_SELECT_CLASS}
                style={{ ...STYLED_SELECT_STYLE, width: 160 }}
              >
                <option value={0}>All Teams</option>
                {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
              <div style={{ width: 290 }}>
                <DateRangePicker value={date} onChange={(_date) => setDate(_date)} />
              </div>
              <select
                value={selectedTimezone}
                onChange={(e) => setSelectedTimezone(e.target.value)}
                className={STYLED_SELECT_CLASS}
                style={{ ...STYLED_SELECT_STYLE, width: 180 }}
              >
                {TIMEZONES.map((tz) => <option key={tz} value={tz}>{tz}</option>)}
              </select>
            </div>
          </div>

          {/* Summary */}
          <div className="flex flex-wrap gap-3 mb-5">
            <StatCard title="Members" value={summary.totalMembers ?? 0} />
            <StatCard title="Instances" value={summary.totalInstances ?? 0} />
            <StatCard title="Total Time (hh:mm:ss)" value={moment.utc((summary.totalTime ?? 0) * 1000).format('HH:mm:ss')} />
          </div>

          {/* Members table */}
          <div className="bg-white border border-rule rounded-[12px] overflow-hidden" style={{ borderStyle: 'solid', boxShadow: '0 1px 2px rgba(14, 30, 64, 0.04)' }}>
            <div className="flex items-center gap-2 px-4 py-3 border-b border-rule" style={{ borderBottomStyle: 'solid' }}>
              <AlertTriangle size={16} className="text-[#CC4525]" />
              <span className="text-sm font-semibold text-ink-900">Members with unusual activity</span>
            </div>
            <DataTable
              bare
              columns={columns}
              rows={members}
              getRowKey={(m) => m.memberId}
              loading={isLoading}
              emptyText="No unusual activity found."
              page={currentPage}
              pageSize={pageSize}
              total={totalCounts}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              minWidth={820}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default UnusualActivity;
